import React, { useContext } from "react";
import CommonModal from "./CommonModal";
import { ModalTitle } from "@src/components/nessie-web";
import { useFormik } from "formik";
import Input from "@src/components/forms/Input";
import Button from "@src/components/Button";
import { validateEmail } from "@src/utils/requests/alternativeAccessMethods";
import { ModalContext, ModalType } from "./ModalController";
import { navigate } from "gatsby";
import { getSubdomainURL } from "@src/utils/getSubdomainURL";

const SignupCombinedModal = ({ closeModal, schoolLeader }: { closeModal: () => void; schoolLeader?: boolean }) => {
  const modalContext = useContext(ModalContext);

  const form = useFormik({
    initialValues: { email: "" },
    validate: (values) => {
      const emailRe = /^(?=\S{3,128}$)[^\s\\;,:]+@[^\s\\;,:.]{1}[^\s\\;,:]*\.[^\s\\;,:0-9]+$/;
      if (!values.email) {
        //TODO translate
        return { email: "Required" };
      } else if (!emailRe.test(values.email)) {
        //TODO translate
        return { email: "Invalid email address" };
      }
      return {};
    },
    validateOnChange: false,
    onSubmit: async ({ email }, { validateForm }) => {
      const errors = await validateForm({ email });
      if (errors.email) {
        return;
      }
      const validation = await validateEmail({ email });
      if (!validation?.isAvailableForSignUp) {
        closeModal();
        if (validation?.entityType === "teacher") {
          modalContext.showModal(ModalType.TeacherLogin, { emailPrefill: email });
        } else if (validation?.entityType === "parent") {
          modalContext.showModal(ModalType.ParentLogin, { emailPrefill: email });
        } else {
          window.location.href = getSubdomainURL("student");
        }
      } else {
        navigate(`/teacher-signup/`, { state: { email, schoolLeader } });
      }
    },
  });

  return (
    <CommonModal closeModal={closeModal}>
      <form onSubmit={form.handleSubmit} style={{ width: "80%", display: "flex", flexDirection: "column", gap: 18 }}>
        {/* TODO translate */}
        <ModalTitle>{schoolLeader ? "Get started as a school leader" : "Get started as a teacher"}</ModalTitle>
        <div>
          <Input
            rounded
            value={form.values.email}
            onChange={form.handleChange}
            onFocus={() => form.setErrors({ email: "" })}
            id="email"
            name="email"
            type="text"
            placeholder="email"
            error={!!form.errors.email && form.touched.email}
            aria-invalid={!!form.errors.email && form.touched.email}
          />
          <div
            style={{
              // set for transition to work when expanding/shrinking
              maxHeight: form.errors.email && form.touched.email ? "14px" : "0px",
              minHeight: form.errors.email ? "14px" : "0px",
              transition: "0.2s",
              fontSize: "14px",
              marginTop: "6px",
              marginLeft: "8px",
            }}
          >
            {form.errors.email}
          </div>
        </div>
        <Button type="submit" style={{ width: "100%", minHeight: "50px" }} size="l">
          {/* TODO translate */}
          Submit
        </Button>
      </form>
    </CommonModal>
  );
};

export default SignupCombinedModal;
